// pickup-location-warning.js

// 1) Core logic: extract unique pickup locations & fire toast
function showPickupLocationWarning(cart) {
  const pickups = cart.items
    .map(item => item.properties.pickup_location)
    .filter(Boolean);

  const unique = [...new Set(pickups)];
  if (unique.length > 1) {
    new ShowToast(
      'warning',
      `Heads up! Only one pickup location is allowed per order at checkout. You have items in your cart from: <b>${unique.join(', ')}.</b>`,
      {
        icon: `
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="50" fill="#f1c600" class="bi bi-exclamation-triangle" viewBox="0 0 16 16">
          <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
          <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
        </svg>
      `
      }
    );
  }
}

// 2) Wire up on page load
document.addEventListener('DOMContentLoaded', () => {
  Shopify.getCart(showPickupLocationWarning);
});

// 3) Re-run whenever Shopify’s AjaxCart updates the cart
if (window.Shopify?.AjaxCart?.api) {
  // hook into their updateCart success
  const originalUpdate = window.Shopify.AjaxCart.api.updateCart;
  window.Shopify.AjaxCart.api.updateCart = function(...args) {
    const result = originalUpdate.apply(this, args);
    // after the drawer refreshes, re-check
    Shopify.getCart(showPickupLocationWarning);
    return result;
  };
}

// 4) If you use your own fetch('/cart/add.js') flow, just do:
async function addToCartWithPickupCheck(variantId, props) {
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1, properties: props })
  });
  if (res.ok) {
    const cart = await (await fetch('/cart.js')).json();
    showPickupLocationWarning(cart);
  }
  return res;
}
